import { render, staticRenderFns } from "./DocumentsWorkspace.vue?vue&type=template&id=3a75c161&scoped=true"
import script from "./DocumentsWorkspace.vue?vue&type=script&lang=js"
export * from "./DocumentsWorkspace.vue?vue&type=script&lang=js"
import style0 from "./DocumentsWorkspace.vue?vue&type=style&index=0&id=3a75c161&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a75c161",
  null
  
)

export default component.exports